import React from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon, SparklesIcon, WalletCardsIcon } from 'lucide-react';
const VALUE_PROPS = [{
  title: 'Cero Estrés',
  description: 'Elegís una de las 250 recetas diseñadas para Argentina, programás el tiempo y te olvidás. Sin vueltas.',
  icon: Clock3Icon
}, {
  title: 'Cero Suciedad',
  description: 'Un solo canasto para limpiar. Olvidate de las hornallas salpicadas con aceite y las 5 ollas en la pileta.',
  icon: SparklesIcon
}, {
  title: 'Más plata en tu cuenta',
  description: 'Invertí hoy lo que sale un solo delivery y comé como un chef todo el año. Se paga solo la primera semana.',
  icon: WalletCardsIcon
}];
export function SmartCookingSection() {
  return <section className="w-full bg-[#102946] py-12 text-white sm:py-20" data-id="element-261" data-mp="28h12slneejqa">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-262" data-mp="28f7wj7gp61it">
        <div className="mx-auto max-w-3xl text-center" data-id="element-263" data-mp="24g7cxmqeauur">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-orange-300" data-id="element-264" data-mp="24hs8nfog4ju7">La forma inteligente de resolver la comida</p>
          <h2 className="mt-4 text-3xl font-black leading-tight sm:text-4xl lg:text-5xl" data-id="element-265" data-mp="15qliw9mrnf1k">
            No necesitás cocinar más… necesitás cocinar <span className="text-orange-400" data-id="element-266" data-mp="19t86tzgbgfth">con inteligencia.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base italic leading-relaxed text-slate-200 sm:text-lg" data-id="element-267" data-mp="1eqqe7leoqmzd">
            Presentamos el sistema que transforma tu Air Fryer de una “tostadora de lujo” a tu propio bodegón personal en solo 15 minutos.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3 sm:mt-12 sm:gap-5" data-id="element-268" data-mp="r1p29o6n8tpc">
          {VALUE_PROPS.map((value, index) => {
          const Icon = value.icon;
          return <motion.article key={value.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 0.35,
            delay: index * 0.08
          }} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-left sm:p-7" data-id="element-269" data-mp="3uj7avxu8q4qt" data-mpi={index}>
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-orange-500 text-white shadow-lg" data-id="element-270" data-mp="1fflzgmn6uz53">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-271" data-mp="1be0esf4exgkc" />
                </span>
                <h3 className="mt-5 text-xl font-black text-orange-300" data-id="element-272" data-mp="no63w33nm22q">{value.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-slate-200" data-id="element-273" data-mp="iputnr9g5pjz">{value.description}</p>
              </motion.article>;
        })}
        </div>

        <p className="mx-auto mt-10 max-w-3xl border-t border-white/15 pt-7 text-center text-base font-bold leading-relaxed text-yellow-100 sm:text-lg" data-id="element-274" data-mp="wn9nr9analia">
          Mirá lo que están logrando las +12.400 familias que ya tienen el manual en su cocina:
        </p>
      </div>
    </section>;
}